import Cookies from "js-cookie";
import { LANGUAGE_COOKIE } from "../i18n/settings";

export async function switchLocaleAction(value: string) {
  try {
    const cookie: any = Cookies.set(LANGUAGE_COOKIE, value, {
      path: "food-order.sparissimofood.com",
    });
    return {
      cookie,
      status: "success",
    };
  } catch (error) {
    console.error("Error setting cookie:", error);
    return {
      error,
      status: "error",
    };
  }
}
